import React, {useMemo} from "react";
import {ImageInfo} from "../../images/ImageInfo";
import {sortByAward} from "../../../data/data";
import styled from 'styled-components';
import {device} from "../../../theme";

export const CompetitionCategory = ({titles, category, innerRef, textColor, finishedLoaded}) => {
    const [cClass, theme] = useMemo(() => category.split("#"), [category, titles])
    const cTitles = useMemo(() => sortByAward(titles?.filter(t => t.theme === theme && t.class === cClass)), [titles]);

    return <Container ref={innerRef} >
        <h1>{cClass} - {theme}</h1>
        {cTitles?.map(title => <ImageInfoStyled key={title.imageId}>
            <ImageInfo title={title} textColor={textColor} finishedLoaded={finishedLoaded}/>
            </ImageInfoStyled>

            )}
    </Container>
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  margin-bottom: 30vh;
  
  h1 {
      font-size: 1.2vw;
    margin-bottom: 20vh;
    padding-top: 10px;
    padding-bottom: 10px;
    background-color: ${(props) => props.theme.color.primary.xxxlight};
    color: ${(props) => props.theme.color.primary.base};
  }

  @media ${device.mobile} {
    margin-bottom: 10vh;
    h1 {
      font-size: 5vw;
      margin-bottom: 5vh;
    }
  }
`

const ImageInfoStyled = styled.div`
  margin-bottom: 100px !important;
`